import { useState, MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Graph } from 'src/components/dashboard/dashboard-grarph/graph'
import { TimeframeButtons } from 'src/components/dashboard/dashboard-grarph/timeframe-buttons.component'
import { EPOCH_TIME_MS } from 'src/constants'
import { useAccountImpactLikes } from 'src/hooks'

interface IProps {
  impactId: string
}

const loadData = [
  { timeframe: '', views: 0 },
  { timeframe: '', views: 0 },
]

export const LikesGraph = ({ impactId }: IProps) => {
  const [t] = useTranslation()
  const [timeframe, setTimeframe] = useState(EPOCH_TIME_MS.ONE_DAY)
  const { data, isFetching } = useAccountImpactLikes(impactId, timeframe)

  const handleTimeframeChange = (_: MouseEvent, val: number) => {
    if (val === null) return
    setTimeframe(val)
  }

  return (
    <div>
      <Graph
        data={isFetching && !data?.data ? loadData : data?.data || []}
        label={t('likes-table-column.v')}
      />
      <TimeframeButtons timeframe={timeframe} handleTimeframeChange={handleTimeframeChange} />
    </div>
  )
}
